module.exports = __webpack_public_path__ + "static/media/event.42a3fbc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/event.svg
// module id = 256
// module chunks = 0